import BaseFeature from '../../foundation/base/base';

export default class LanguagePicker extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.initDomCache();

		this.initEvents();
	}

	initEvents() {
		this.addEventListener(this.dom.expand, 'click', (e) => {
			e.preventDefault();
			this.expand();
		});
	}

	expand() {
		const items = this.el.querySelectorAll('.o-related-items__hidden');
		for (let i = 0; i < 4; i++) {
			if (items[i]) items[i].classList.remove('o-related-items__hidden');
		}
		if (items.length <= 4) this.hideExpand();
	}

	hideExpand() {
		this.dom.expand.classList.add('o-related-items__expand--hidden');
	}
}
